module.exports = __webpack_public_path__ + "img/lunbo132.9f1c12f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo132.png
// module id = KKBj
// module chunks = 0